"use client";
import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./FilterGroups.scss";
import CustomStringAttributeFilter from "../Filters/CustomStringAttributeFilter";
import CustomStringAttributeNestedFilter from "../Filters/CustomStringAttributeNestedFilter";
import SalaryFilter from "../Filters/SalaryFilter";
import RemoteWorkingFilter from "../Filters/RemoteWorkingFilter";
import featureService from "../../services/FeatureService";
import Fallback from "../Fallback/Fallback";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { filtersAtomObject, originalFiltersAtomObject } from "../../state";
import CommuteFilter from "../Filters/CommuteFilter";

const FilterGroups = ({ onChange }) => {
  const [isActive, setIsActive] = useState(false);
  const [filterGroupVisibility, setFilterGroupVisibility] = useState({
    commute: true,
    customStringAttributes: true,
    customStringAttributes1: true,
    customStringAttributes2: true,
    customStringAttributes3: true,
    customStringAttributes4: true,
    type: true,
    salary: true,
  });

  const [filters, setFilters] = useAtom(filtersAtomObject);
  const [data] = useAtom(originalFiltersAtomObject);

  const toggleMobileFilters = () => {
    setIsActive((prevState) => !prevState);
  };

  const toggleFilterGroup = (filterGroup) => {
    setFilterGroupVisibility((prevVisibility) => ({
      ...prevVisibility,
      [filterGroup]: !prevVisibility[filterGroup],
    }));
  };

  const toggleContainerRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (isActive) {
      document.body.classList.add("open-filters");
      toggleContainerRef.current.scrollTop = 0;
    } else {
      document.body.classList.remove("open-filters");
    }
  }, [isActive]);

  const logError = (error, info) => {};

  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onError={logError}
      beforeCapture={(scope) => {
        scope.setTag("location", "FilterGroups.jsx");
      }}
    >
      <div
        className={`job-search-filters ${
          isActive ? "toggle-filters-panel" : ""
        }`}
      >
        <h4 className="xs-heading">
          <span>{t("refine_results")}</span>
          <span
            className={`toggle-filters ${isActive ? "toggle-open" : ""}`}
            onClick={toggleMobileFilters}
          >
            <i></i>
            {t(isActive ? "close_filters" : "show_filters")}
          </span>
        </h4>
        <div
          className={`form-holder toggle-container ${
            isActive ? "toggle-open" : ""
          }`}
          ref={toggleContainerRef}
        >
          <h4 className="xs-heading">
            {t("filters")}
            <span
              className={`toggle-filters ${isActive ? "toggle-open" : ""}`}
              onClick={toggleMobileFilters}
            >
              <i></i>
              {t(isActive ? "close_filters" : "show_filters")}
            </span>
          </h4>

          <Form>
            {data.remoteEnabled && (
              <RemoteWorkingFilter
                onChange={(v) => setFilters({ ...filters, remoteWorking: v })}
                initialState={filters.remoteWorking}
              />
            )}

            {featureService.isAllowed(["1GJjwqtmVX"]) &&
              featureService.isAllowed(["ZLE7ejYSEd"]) &&
              featureService.isAllowed(["CommuteSearch", "ZLE7ejYSEd"]) && (
                <div
                  className={`filter-group ${
                    filterGroupVisibility["commute"] ? "open-filters" : ""
                  }`}
                >
                  <div
                    className="filter-heading"
                    onClick={() => toggleFilterGroup("commute")}
                  >
                    {t("commute_search")}
                  </div>
                  {filterGroupVisibility["commute"] && <CommuteFilter />}
                </div>
              )}

            {data?.customStringAttributes1?.result?.filter((x) =>
              featureService.isAllowed(["cMp8rdyHb2"])
                ? x.predefinedIdCount > 0
                : x.count > 0
            ).length > 0 && (
              <div
                className={`filter-group ${
                  filterGroupVisibility["customStringAttributes1"]
                    ? "open-filters"
                    : ""
                }`}
              >
                <div
                  className="filter-heading"
                  onClick={() => toggleFilterGroup("customStringAttributes1")}
                >
                  {data?.customStringAttributes1?.title} {t("search")}
                </div>
                {filterGroupVisibility["customStringAttributes1"] &&
                  (featureService.isAllowed(["cMp8rdyHb2"]) ? (
                    <CustomStringAttributeNestedFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes1: v })
                      }
                      initialState={filters.customStringAttributes1}
                      data={data?.customStringAttributes1?.result}
                    />
                  ) : (
                    <CustomStringAttributeFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes1: v })
                      }
                      initialState={filters.customStringAttributes1}
                      data={data?.customStringAttributes1?.result}
                    />
                  ))}
              </div>
            )}

            {data?.customStringAttributes2?.result?.filter((x) =>
              featureService.isAllowed(["cMp8rdyHb2"])
                ? x.predefinedIdCount > 0
                : x.count > 0
            ).length > 0 && (
              <div
                className={`filter-group ${
                  filterGroupVisibility["customStringAttributes2"]
                    ? "open-filters"
                    : ""
                }`}
              >
                <div
                  className="filter-heading"
                  onClick={() => toggleFilterGroup("customStringAttributes2")}
                >
                  {data?.customStringAttributes2?.title} {t("search")}
                </div>
                {filterGroupVisibility["customStringAttributes2"] &&
                  (featureService.isAllowed(["cMp8rdyHb2"]) ? (
                    <CustomStringAttributeNestedFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes2: v })
                      }
                      initialState={filters.customStringAttributes2}
                      data={data?.customStringAttributes2.result}
                    />
                  ) : (
                    <CustomStringAttributeFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes2: v })
                      }
                      initialState={filters.customStringAttributes2}
                      data={data?.customStringAttributes2.result}
                    />
                  ))}
              </div>
            )}

            {data?.customStringAttributes3?.result?.filter((x) =>
              featureService.isAllowed(["cMp8rdyHb2"])
                ? x.predefinedIdCount > 0
                : x.count > 0
            ).length > 0 && (
              <div
                className={`filter-group ${
                  filterGroupVisibility["customStringAttributes3"]
                    ? "open-filters"
                    : ""
                }`}
              >
                <div
                  className="filter-heading"
                  onClick={() => toggleFilterGroup("customStringAttributes3")}
                >
                  {data?.customStringAttributes3?.title} {t("search")}
                </div>
                {filterGroupVisibility["customStringAttributes3"] &&
                  (featureService.isAllowed(["cMp8rdyHb2"]) ? (
                    <CustomStringAttributeNestedFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes3: v })
                      }
                      initialState={filters.customStringAttributes3}
                      data={data?.customStringAttributes3?.result}
                    />
                  ) : (
                    <CustomStringAttributeFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes3: v })
                      }
                      initialState={filters.customStringAttributes3}
                      data={data?.customStringAttributes3?.result}
                    />
                  ))}
              </div>
            )}

            {data?.customStringAttributes4?.result?.filter((x) =>
              featureService.isAllowed(["cMp8rdyHb2"])
                ? x.predefinedIdCount > 0
                : x.count > 0
            ).length > 0 && (
              <div
                className={`filter-group ${
                  filterGroupVisibility["customStringAttributes4"]
                    ? "open-filters"
                    : ""
                }`}
              >
                <div
                  className="filter-heading"
                  onClick={() => toggleFilterGroup("customStringAttributes4")}
                >
                  {data?.customStringAttributes4?.title} {t("search")}
                </div>
                {filterGroupVisibility["customStringAttributes4"] &&
                  (featureService.isAllowed(["cMp8rdyHb2"]) ? (
                    <CustomStringAttributeNestedFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes4: v })
                      }
                      initialState={filters.customStringAttributes4}
                      data={data?.customStringAttributes4?.result}
                    />
                  ) : (
                    <CustomStringAttributeFilter
                      onChange={(v) =>
                        setFilters({ ...filters, customStringAttributes4: v })
                      }
                      initialState={filters.customStringAttributes4}
                      data={data?.customStringAttributes4?.result}
                    />
                  ))}
              </div>
            )}

            {featureService.isAllowed(["dKJI7BxCn1"]) &&
              data.salaries?.types?.filter((x) => x.count > 0).length > 0 && (
                <div
                  className={`filter-group ${
                    filterGroupVisibility["salary"] ? "open-filters" : ""
                  }`}
                >
                  <div
                    className="filter-heading"
                    onClick={() => toggleFilterGroup("salary")}
                  >
                    {t("salary_search")}
                  </div>
                  {filterGroupVisibility["salary"] && (
                    <SalaryFilter
                      onChange={(v) =>
                        setFilters({
                          ...filters,
                          salary: {
                            type: v.salaryType,
                            minimum: v.salaryMinimum,
                            currencyCode: v.currencyCode,
                          },
                        })
                      }
                      data={data}
                      initialState={{ value: filters.salary }}
                    />
                  )}
                </div>
              )}

            <div className="btn show-results" onClick={toggleMobileFilters}>
              <span>{t("show_results")}</span>
            </div>
          </Form>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default FilterGroups;
